import React, { createContext, useContext } from 'react';

export const BookingNavbarContext = createContext({
  setContinueAction: null,
  hideContinueButton: null,
  setHideContinueButton: null,
  setIsPriceLoading: null,
  navbarRef: null,
  currentPage: null,
  setNoEdit: null,
  setOverwriteContinueButton: null,
  setPortalPosition: null,
  setIsDisabled: null,
  setValidationCallback: null,
  validationCallback: () => null,
  setProcessValidation: null,
  setPaymentLabel: null,
  setContinueBtn: null,
  setShouldDisplay: null,
  setPriceShouldIncludeDonation: null,
});

type BookingNavbarProviderProps = {
  children: React.ReactNode;
  hideContinueButton?: boolean;
  currentPage?: string;
  setContinueAction?: () => void;
  setHideContinueButton?: () => void;
  setIsPriceLoading?: () => void;
  navbarRef?: any;
  setNoEdit?: () => void;
  setPriceShouldIncludeDonation?: () => void;
  setShouldDisplay?: () => void;
  setOverwriteContinueButton?: () => void;
  setPortalPosition?: () => void;
  setIsDisabled?: () => void;
  validationCallback?: () => void;
  setValidationCallback?: () => void;
  setProcessValidation?: () => void;
  setContinueBtn?: () => void;
  setPaymentLabel?: () => void;
};

export const BookingNavbarProvider = ({
  setContinueAction,
  hideContinueButton,
  setHideContinueButton,
  setIsPriceLoading,
  setShouldDisplay,
  navbarRef,
  currentPage,
  validationCallback,
  setNoEdit,
  setOverwriteContinueButton,
  setContinueBtn,
  setPriceShouldIncludeDonation,
  setPortalPosition,
  setIsDisabled,
  setValidationCallback,
  setProcessValidation,
  setPaymentLabel,
  children,
}: BookingNavbarProviderProps) => {
  return (
    <BookingNavbarContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        setContinueAction,
        hideContinueButton,
        setHideContinueButton,
        setIsPriceLoading,
        setShouldDisplay,
        setPriceShouldIncludeDonation,
        navbarRef,
        currentPage,
        validationCallback,
        setNoEdit,
        setContinueBtn,
        setOverwriteContinueButton,
        setPortalPosition,
        setIsDisabled,
        setValidationCallback,
        setProcessValidation,
        setPaymentLabel,
      }}
    >
      {children}
    </BookingNavbarContext.Provider>
  );
};

export const useBookingNavbarContext = () => {
  return useContext(BookingNavbarContext);
};
